<template>
  <div class="container" style="margin-bottom: 40px">
    <case-menu @caseSelect="caseSelect"></case-menu>
    <div class="page-title">研发企业合作案例</div>
    <div style="margin-top: 90px;padding-left: 50px">
      <div class="flexRow">
        <div class="flexRow-left">
          <img  src="../../assets/img/case/shybk.png" data-aos="zoom-in" width="450px"/>
        </div>
        <div class="flexRow-right" data-aos="fade-up">
          <div class="model-ra"></div>
          <div style="width: 48px;height: 48px"></div>
          <div class="flexRow-word">
            <div class="flex-title">上海生物样本库（原“上海张江生物银行”）</div>
            <div class="flex-line"></div>
            <div class="flex-title-r">项目启动于2013年</div>
            <div class="flex-title-d">
              上海生物样本库（原上海张江生物银行）由上海浦东张江管委会立项，由生物芯片上海国家工程研究中心旗下上海芯超生物科技有限公司牵头承建。该样本库已取得科技部人类遗传资源保藏行政许可。
            </div>
            <div class="flex-title-d">
              上海唐颐信息技术有限公司为该样本库提供生物样本库信息管理系统，并与其合作研发第三方商业生物样本库管理平台，输出面向生物样本库场景的专业化大数据定制解决方案。
            </div>
          </div>
        </div>
      </div>
      <div class="flexRow">
        <div class="flexRow-right" data-aos="fade-up">
          <div class="flexRow-word other-rec">
            <div class="flex-title">金域医学</div>
            <div class="flex-line"></div>
            <div class="flex-title-d">
              金域医学和唐颐信息于2022年达成战略合作，旨在国家大力推动科技创新及成果转化的大环境下，通过建设一个总库下设多个分库（一库多点），统一标准(程序、操作规程等)，统一监管（政策、科学与伦理等）,生物样本的入、出库等，最终实现覆盖样本/细胞生命周期全流程链的信息管理，并以样本（源）为核心主体将各模块系统及相关系统/数据库（组学大数据，体检中心系统，共建实验系统）的有效信息进行关联，快速便捷地实现数据查询和样本检索，并实现样本全流程双向追踪的生物资源中心信息管理系统。
            </div>
          </div>
        </div>
        <div class="flexRow-left" style="background: white">
          <img  src="../../assets/img/case/jyyx.png" data-aos="zoom-in" width="450px"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CaseMenu from "../../components/CaseMenu";
export default {
  name: "company",
  components: {
    CaseMenu
  },
  methods:{
    caseSelect(src){
      this.$emit('caseSelect',src)
    }
  }
}
</script>

<style scoped lang="less">
.page-title{
  font-size: 36px;
  color: red;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
}
.container{
  width: 100%;
  padding-left: 20%;
  box-sizing: border-box;
  position: relative;
}
.flexRow{
  display: flex;
  height: 450px;
  .flexRow-left{
    width: 50%;
    background: #0b96fa;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .flexRow-right{
    width: 50%;

    .flexRow-word{
      position: relative;
      top: -70px;
      left: 70px;
    }
  }
  .model-ra{
    width: 48px;
    height: 48px;
    background: #6cabfe;
    position: relative;
    top: 30px;
    left: -25px;
  }
  .icon{
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #ffffff;
    position: relative;
    top: 70px;
    left: -25px;
  }
  .flex-title{
    font-size: 19px;
    color: #006efd;
    font-weight: bold;
  }
  .flex-line{
    margin-top: 15px;
    width: 70px;
    height: 6px;
    background: #0b96fa;
  }
  .flex-title-r{
    font-size: 16px;
    margin-top: 30px;
  }
  .flex-title-d{
    width: 80%;
    font-size: 16px;
    margin-top: 30px;
    line-height: 30px;
    text-align: justify-all;
    text-indent: 32px;
  }
  .other-rec{
    margin-top: 30px;
    position: relative;
    top: 0px!important;
    left: 0px!important;
  }
  .flex-title-ul{
    width: 100%;
    height: 40%;
    display: flex;
    align-items: center;
    justify-content: start;
    font-size: 16px;
    padding-top: 40px;
    padding-left: 40px;
    li{
      height: 40px;
    }
  }

}
</style>
